var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 15.287",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.973 5.779a.8.8 0 0 0-.687-.535l-4.546-.663L8.703.451a.8.8 0 0 0-1.438 0L5.228 4.573l-4.546.671a.787.787 0 0 0-.447 1.342l3.3 3.2-.8 4.538a.8.8 0 0 0 1.174.863l4.075-2.138 4.074 2.133a.743.743 0 0 0 .367.1.8.8 0 0 0 .791-.951l-.8-4.538 3.3-3.2a.8.8 0 0 0 .257-.814Zm-4.913 3.2a.8.8 0 0 0-.232.7l.575 3.355-3-1.6a.847.847 0 0 0-.751 0l-3 1.6.575-3.355a.8.8 0 0 0-.232-.7l-2.4-2.4 3.363-.487a.8.8 0 0 0 .607-.439l1.419-3.045 1.5 3.052a.8.8 0 0 0 .607.439l3.363.487Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.384e9a89f424bbcd72c7062de05df6dc.svg";
export { ForwardRef as ReactComponent };